import React from "react";

const IconLogout: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="21"
      viewBox="0 0 27 21"
      fill="none"
    >
      <path
        d="M8.69231 5.75V3.375C8.69231 2.74511 8.94557 2.14102 9.39638 1.69562C9.84719 1.25022 10.4586 1 11.0962 1H23.5962C24.2337 1 24.8451 1.25022 25.2959 1.69562C25.7467 2.14102 26 2.74511 26 3.375V17.625C26 18.2549 25.7467 18.859 25.2959 19.3044C24.8451 19.7498 24.2337 20 23.5962 20H11.0962C10.4586 20 9.84719 19.7498 9.39638 19.3044C8.94557 18.859 8.69231 18.2549 8.69231 17.625V15.25M14.4615 15.25L19.2692 10.5L14.4615 5.75M1 10.5H18.3077"
        stroke="#4FD1C5"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default IconLogout;
